import { Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
// import { useEffect, useRef } from "react";

import Home from "./component/Home";
import TermsConditions from "./component/TermsConditions";
import AboutUs from "./component/AboutUs";
import PrivacyPolicy from "./component/policies/PrivacyPolicy";
import FAQ from "./component/FAQ";
import ContactUs from "./component/ContactUs";
import InterestRatePolicy from "./component/policies/InterestRatePolicy";
import RiskManagementPolicy from "./component/policies/RiskManagementPolicy";
import KYCAmlPolicy from "./component/policies/KYCAmlPolicy";
import CancellationRefundPolicy from "./component/policies/CancellationRefundPolicy";
import FairPracticeCode from "./component/FairPracticeCode";
import CorporateGovernance from "./component/CorporateGovernance";
// import RepaymentNow from "./component/RepayNow";
import AccountDeletionPolicy from "./component/policies/AccountDeletionPolicy";
import FraudTicker from "./component/FraudTicker";

// Lazy so framer-motion (chatbot-only) stays out of the initial bundle.
const ChatBot = lazy(() => import("./component/ChatBot"));
// import Blog from "./component/Blog";
// import BlogDetails from "./component/BlogDetails";

// const ExternalRedirect = ({ to }: { to: string }) => {
//   const navigate = useNavigate();
//   const hasOpened = useRef(false);

//   useEffect(() => {
//     if (!hasOpened.current) {
//       hasOpened.current = true;
//       window.open(to, "_blank");
//       navigate("/", { replace: true });
//     }
//   }, [to, navigate]);
//   return null;
// };


function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/about" element={<AboutUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<ContactUs />} />
        {/* <Route path="/blog" element={<Blog />} /> */}
        {/* <Route path="/blog/:id" element={<BlogDetails />} /> */}
        <Route path="/loan-calculator" element={<Navigate to="/" replace />} />
        <Route path="/terms-condition" element={<TermsConditions />} />
        {/* <Route path="/repay" element={<ExternalRedirect to={`${import.meta.env.VITE_WEBSITE_LINK}/repay-now`} />} /> */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/interest-rate-policy" element={<InterestRatePolicy />} />
        <Route path="/risk-management-policy" element={<RiskManagementPolicy />} />
        <Route path="/cancellation-refund-policy" element={<CancellationRefundPolicy />} />
        <Route path="/fair-practice-code" element={<FairPracticeCode />} />
        <Route path="/corporate-governance" element={<CorporateGovernance />} />
        <Route path="/kyc-aml-policy" element={<KYCAmlPolicy />} />
        <Route path="/account-delete-policy" element={<AccountDeletionPolicy />} />

      </Routes>
      <Suspense fallback={null}>
        <ChatBot />
      </Suspense>
      <FraudTicker />
    </>
  );
}

export default App;
